import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

// "Sign in with Google" button — must follow Google's brand guidelines (white
// surface, accent-subtle border, the Google mark), so it deviates from the
// default Pluma secondary button.
const googleAuthButtonBase = {
  borderRadius: themeVars.radius['4'],
  // eslint-disable-next-line local-rules/enforce-theme-tokens -- Google brand-guideline padding, not a Pluma token
  paddingRight: '12px',
  display: 'flex',
  background: themeVars.color['surface-base'],
  border: `${themeVars.border['width-0125']} solid ${themeVars.color['border-accent-subtle']}`,
  selectors: {
    '&:hover': { backgroundColor: themeVars.color['surface-subtle-hover'] },
    '&[disabled]': { opacity: 0.5, cursor: 'default' },
    '&[disabled]:hover': { backgroundColor: themeVars.color['surface-base'] },
  },
} as const;

// Login screens: hug the content (light theme).
export const googleAuthButton = style(
  {
    ...googleAuthButtonBase,
    width: 'fit-content',
  },
  'google-auth-button',
);

// Dark theme — used by the re-auth modal (Ember's `@theme='dark'`): dark surface,
// white text, no border.
export const googleAuthButtonDark = style(
  {
    borderRadius: themeVars.radius['4'],
    // eslint-disable-next-line local-rules/enforce-theme-tokens -- Google brand-guideline padding, not a Pluma token
    paddingRight: '12px',
    display: 'flex',
    width: 'fit-content',
    background: themeVars.color['surface-invert-bold'],
    border: `${themeVars.border['width-0125']} solid transparent`,
    color: themeVars.color['text-white'],
    selectors: {
      '&:hover': { background: themeVars.color['surface-invert-bold-hover'] },
      '&[disabled]': { opacity: 0.5, cursor: 'default' },
      '&[disabled]:hover': { background: themeVars.color['surface-invert-bold'] },
    },
  },
  'google-auth-button-dark',
);

// Signup-style usage (email step "Continue with Google"): full width, centered.
export const googleSignupButton = style(
  {
    ...googleAuthButtonBase,
    width: '100%',
    justifyContent: 'center',
    // eslint-disable-next-line local-rules/enforce-theme-tokens -- Google brand-guideline padding, not a Pluma token
    paddingLeft: '12px',
    color: themeVars.color['text-base'],
  },
  'google-signup-button',
);
